import React from 'react';
import PropTypes from 'prop-types';

function SvgBell({ fill, ...props }) {
  return (
    <svg width="1.5em" height="1.5em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15.0363 19.4523C15.0363 21.2246 13.5996 22.6614 11.8273 22.6614C10.0549 22.6614 8.61816 21.2246 8.61816 19.4523H15.0363Z"
        stroke="#FDB913"
      />
      <path
        d="M5.73066 9.02272L5.24035 8.92475L5.23558 8.94861L5.23315 8.97283L5.73066 9.02272ZM18.3378 9.02272H18.8378V8.97326L18.8281 8.92475L18.3378 9.02272ZM14.441 3.88124H13.941V4.21011L14.243 4.34036L14.441 3.88124ZM9.62741 3.88123L9.82543 4.34035L10.1274 4.2101V3.88123H9.62741ZM18.3378 13.8364H17.8378V13.9928L17.927 14.1214L18.3378 13.8364ZM5.24791 13.8364L5.68399 14.081L5.73501 13.99L5.74542 13.8862L5.24791 13.8364ZM20.9183 17.8392L20.4198 17.8781L20.9183 17.8392ZM20.6463 17.1637L21.0571 16.8787L20.6463 17.1637ZM3.15989 17.7419L2.66356 17.6814L3.15989 17.7419ZM3.34412 17.2302L2.90804 16.9856L3.34412 17.2302ZM4.44564 19.9523H19.6228V18.9523H4.44564V19.9523ZM19.6228 19.9523C20.2306 19.9523 20.7231 19.6951 21.0395 19.2676C21.3451 18.8547 21.4577 18.3241 21.4168 17.8003L20.4198 17.8781C20.4465 18.2196 20.3669 18.4955 20.2357 18.6727C20.1152 18.8355 19.9262 18.9523 19.6228 18.9523V19.9523ZM2.66356 17.6814C2.59719 18.2261 2.69375 18.7838 2.9955 19.2208C3.30869 19.6743 3.81367 19.9523 4.44564 19.9523V18.9523C4.13244 18.9523 3.93938 18.8278 3.81839 18.6526C3.68598 18.4608 3.61225 18.1632 3.65622 17.8023L2.66356 17.6814ZM10.1274 3.40682C10.1274 2.35371 10.9811 1.5 12.0342 1.5V0.5C10.4288 0.5 9.12741 1.80143 9.12741 3.40682H10.1274ZM12.0342 1.5C13.0873 1.5 13.941 2.35371 13.941 3.40682H14.941C14.941 1.80143 13.6396 0.5 12.0342 0.5V1.5ZM14.243 4.34036C15.6676 4.9548 16.5707 6.13026 17.1235 7.19093C17.3983 7.71814 17.5807 8.20627 17.6941 8.56176C17.7507 8.73913 17.7898 8.88245 17.8144 8.97979C17.8267 9.02843 17.8353 9.0655 17.8407 9.08951C17.8434 9.10151 17.8453 9.11023 17.8464 9.11549C17.8469 9.11812 17.8473 9.11989 17.8475 9.12076C17.8476 9.1212 17.8476 9.12141 17.8476 9.1214C17.8476 9.1214 17.8476 9.12133 17.8476 9.12121C17.8476 9.12116 17.8475 9.12102 17.8475 9.12099C17.8475 9.12085 17.8475 9.12069 18.3378 9.02272C18.8281 8.92475 18.8281 8.92456 18.828 8.92436C18.828 8.92427 18.828 8.92405 18.8279 8.92388C18.8279 8.92353 18.8278 8.92312 18.8277 8.92266C18.8275 8.92173 18.8273 8.92057 18.827 8.91918C18.8264 8.9164 18.8256 8.91271 18.8247 8.90814C18.8227 8.89899 18.82 8.88628 18.8164 8.87021C18.8091 8.83808 18.7985 8.79246 18.7839 8.7349C18.7549 8.61984 18.7103 8.4567 18.6468 8.25786C18.5202 7.86093 18.3172 7.31763 18.0103 6.72876C17.3998 5.55727 16.3545 4.16198 14.6391 3.42212L14.243 4.34036ZM14.941 3.88124V3.40682H13.941V3.88124H14.941ZM5.73066 9.02272C6.22097 9.12069 6.22093 9.12085 6.2209 9.12099C6.2209 9.12102 6.22087 9.12116 6.22086 9.12121C6.22084 9.12133 6.22082 9.1214 6.22082 9.1214C6.22082 9.12141 6.22086 9.1212 6.22095 9.12076C6.22113 9.11989 6.2215 9.11812 6.22206 9.11549C6.22317 9.11023 6.22505 9.1015 6.22775 9.08951C6.23315 9.0655 6.2418 9.02843 6.25408 8.97979C6.27867 8.88245 6.31773 8.73913 6.37431 8.56176C6.4877 8.20627 6.67014 7.71814 6.94491 7.19093C7.49772 6.13025 8.4008 4.9548 9.82543 4.34035L9.42939 3.42212C7.71398 4.16198 6.66868 5.55727 6.05812 6.72875C5.75121 7.31763 5.54822 7.86093 5.4216 8.25786C5.35818 8.4567 5.31359 8.61984 5.28453 8.7349C5.26999 8.79246 5.25932 8.83808 5.25209 8.87021C5.24848 8.88628 5.24573 8.89899 5.24379 8.90814C5.24282 8.91271 5.24205 8.9164 5.24148 8.91918C5.2412 8.92057 5.24096 8.92173 5.24077 8.92266C5.24068 8.92312 5.24059 8.92353 5.24052 8.92388C5.24049 8.92405 5.24045 8.92427 5.24043 8.92436C5.24039 8.92456 5.24035 8.92475 5.73066 9.02272ZM10.1274 3.88123V3.40682H9.12741V3.88123H10.1274ZM21.0571 16.8787L18.7486 13.5513L17.927 14.1214L20.2355 17.4487L21.0571 16.8787ZM18.8378 13.8364V9.02272H17.8378V13.8364H18.8378ZM3.78019 17.4748L5.68399 14.081L4.81184 13.5917L2.90804 16.9856L3.78019 17.4748ZM5.74542 13.8862L6.22816 9.07261L5.23315 8.97283L4.75041 13.7865L5.74542 13.8862ZM21.4168 17.8003C21.3878 17.4289 21.222 17.1163 21.0571 16.8787L20.2355 17.4487C20.3521 17.6168 20.4104 17.7572 20.4198 17.8781L21.4168 17.8003ZM3.65622 17.8023C3.66726 17.7117 3.7064 17.6063 3.78019 17.4748L2.90804 16.9856C2.80281 17.1732 2.69677 17.4088 2.66356 17.6814L3.65622 17.8023Z"
        fill="#FDB913"
      />
      <path
        d="M22.4636 9.0229C23.2658 5.81377 21.2601 2.60468 18.4523 1.80243"
        stroke="#FDB913"
        strokeLinecap="round"
      />
      <path
        d="M1.53641 9.0229C0.734208 5.81377 2.73989 2.60468 5.54775 1.80243"
        stroke="#FDB913"
        strokeLinecap="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="11.8273"
          y1="19.4523"
          x2="11.8273"
          y2="22.6614"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FDB913" />
          <stop offset="1" stop-color="#FDB913" />
        </linearGradient>
        <linearGradient id="paint1_linear" x1="12.0342" y1="1" x2="12.0342" y2="19.4523" gradientUnits="userSpaceOnUse">
          <stop stop-color="#FDB913" />
          <stop offset="1" stop-color="#FDB913" />
        </linearGradient>
        <linearGradient
          id="paint2_linear"
          x1="21.2261"
          y1="2.54568"
          x2="19.6897"
          y2="8.27964"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FDB913" />
          <stop offset="1" stop-color="#F2994A" />
        </linearGradient>
        <linearGradient
          id="paint3_linear"
          x1="2.77387"
          y1="2.54568"
          x2="4.31028"
          y2="8.27964"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FDB913" />
          <stop offset="1" stop-color="#F2994A" />
        </linearGradient>
      </defs>
    </svg>
  );
}

SvgBell.propTypes = {
  fill: PropTypes.string,
};

SvgBell.defaultProps = {
  fill: '#fff',
};

export default SvgBell;
